import config from "config/config";
import useUserContext from "hooks/context-hooks/useUserContext";
import { useEffect, useState, useCallback } from "react";
import { GET } from "utils/restUtils";

export const useFetchPinnedLogs = (patientId: string) => {
  const [data, setData] = useState<any[] | null>(null);
  const [loading, setLoading] = useState<boolean>(!!patientId);
  const [error, setError] = useState<unknown>(null);

  const { user } = useUserContext();

  const fetchPinnedLogs = useCallback(async () => {
    if (!patientId || !user?.token) return;

    try {
      setLoading(true);
      const response = await GET(
        `${config.BASE_URL}/api/v1/communication_logs/${patientId}?api_token=${user.token}`
      );
      setData(response.data.data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [patientId, user?.token]);

  useEffect(() => {
    fetchPinnedLogs();
  }, [fetchPinnedLogs]);

  return [data, loading, fetchPinnedLogs];
};
